import { z } from "zod";
import { defaultIdLength } from "./makeIdGenerator";

export function getIdSchema<Prefix extends string>(
  prefix: Prefix,
  name: string,
  minIdLength = defaultIdLength,
) {
  // Deterministic 16-char body so the OpenAPI example matches the regex
  // and is obviously fake.
  const example = `${prefix}1a2b3c4d5e6f7g8h`;
  const pattern = `^${prefix}[a-z0-9]{${minIdLength},24}$`;
  return z
    .string()
    .regex(new RegExp(pattern, "i"), {
      message: `Must be in the format ${prefix}[${minIdLength}-24 alphanumeric characters]`,
    })
    .transform((id) => id as `${Prefix}${string}`)
    .meta({
      id: name,
      example,
      // The transform makes Zod's generated output JSON Schema lose the
      // string type + pattern. Repeat them in `meta` so both input and
      // output components render with the full validation hints.
      type: "string",
      pattern,
    });
}
